import { getMargins } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
export const StyledList = styled.ul `
  margin: ${(props) => getMargins(props.margin) || 0};
  padding: 0;
`;
//# sourceMappingURL=index.styles.js.map